import { Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { clsx } from 'clsx'
import { Check, Mic, UserPlus } from 'lucide-react'
import { InviteParticipantModal } from './InviteParticipantModal'

interface WaitingForAnotherParticipantProps {
  micReady: boolean
  inviteLink: string
  inviteOpen: boolean
  onInviteOpenChange: (open: boolean) => void
}

export function WaitingForAnotherParticipant({
  micReady,
  inviteLink,
  inviteOpen,
  onInviteOpenChange
}: WaitingForAnotherParticipantProps) {
  return (
    <>
      <div className="flex items-center gap-12">
        <div className="flex flex-col items-center gap-2">
          <div className="relative flex items-center justify-center" style={{ width: 96, height: 96 }}>
            {micReady && (
              <div className="bg-green absolute top-2 right-0 z-2 flex h-8 w-8 items-center justify-center rounded-full border-2 border-solid border-white">
                <Check />
              </div>
            )}
            <div className="bg-black-to-white flex size-24 items-center justify-center rounded-full">
              <div
                className={clsx(
                  'relative z-1 flex size-20 items-center justify-center rounded-full text-white shadow-lg',
                  micReady ? 'bg-gray-100' : 'bg-gray-90 animate-pulse'
                )}
              >
                <Mic className="size-8" />
              </div>
            </div>
          </div>
          <div className="text-body-2 text-gray-90">
            <Trans>Participant 1 (You)</Trans>
          </div>
          <div className="flex items-center gap-2">
            {!micReady && <span className={clsx('bg-green size-2.5 animate-pulse rounded-full')} />}
            <Text type="body2-regular" className="text-gray-90">
              {micReady ? <Trans>Mic ready</Trans> : <Trans>Waiting for microphone...</Trans>}
            </Text>
          </div>
        </div>

        <button
          type="button"
          className="flex cursor-pointer flex-col items-center gap-2 bg-transparent"
          onClick={() => onInviteOpenChange(true)}
        >
          <div className="relative flex items-center justify-center" style={{ width: 96, height: 96 }}>
            <div className="bg-black-to-white flex size-24 items-center justify-center rounded-full transition-opacity hover:opacity-80">
              <div className="flex size-20 items-center justify-center rounded-full bg-gray-100">
                <UserPlus className="size-8" />
              </div>
            </div>
          </div>
          <div className="text-body-2 text-gray-70">
            <Trans>Tap to invite</Trans>
          </div>
          <div className="flex items-center gap-2">
            <Text type="body2-regular" className="text-gray-90">
              <Trans>Waiting for participant...</Trans>
            </Text>
          </div>
        </button>

        <InviteParticipantModal open={inviteOpen} onOpenChange={onInviteOpenChange} inviteLink={inviteLink} />
      </div>
    </>
  )
}
